import FileService from '../../services/file-service';
import { FILE_EXTENSION_LIST_IMAGE } from '../../constants/system/file-extensions';

const AssetValidator: Validator = (values: FormValues): ValidationErrors => {
  const errors: ValidationErrors = {};

  const assetRequiredFields: string[] = [
    'name',
    'portfolioId',
    'status',
  ];

  const sellerRequiredFields: string[] = [
    'name',
  ];

  const assetAllocationItemRequiredFields: string[] = [
    'portfolioId',
    'value',
  ];

  if (values.assetData) {
    const assetData: ValidationEntityInput = {
      ...values.assetData,
    };

    if (!errors.assetData) {
      errors.assetData = {};
    }

    assetRequiredFields.forEach((field: string): void => {
      if (!assetData[field] || !assetData[field].toString().trim()) {
        errors.assetData[field] = 'Required';
      }
    });

    if (assetData.seller && Object.keys(assetData.seller).length) {
      if (!errors.assetData.seller) {
        errors.assetData.seller = {};
      }

      sellerRequiredFields.forEach((field: string): void => {
        if (!assetData.seller[field] || !assetData.seller[field].toString().trim()) {
          errors.assetData.seller[field] = 'Required';
        }
      });

      if (errors.assetData.seller && !Object.keys(errors.assetData.seller).length) {
        delete errors.assetData.seller;
      }
    }

    if (!assetData.address && assetData.streetAddress) {
      errors.assetData.streetAddress = 'Incorrect address value';
    }

    if (assetData.mainPhoto && !FileService.checkFileExtension(assetData.mainPhoto, FILE_EXTENSION_LIST_IMAGE)) {
      errors.assetData.mainPhoto = 'Incorrect file type';
    }

    if (assetData.allocationItems && Object.keys(assetData.allocationItems).length) {
      if (!errors.assetData.allocationItems) {
        errors.assetData.allocationItems = {};
      }

      const portfolioIds: number[] = [];

      Object.keys(assetData.allocationItems).forEach((assetAllocationItemIndex: string): void => {
        const assetAllocationItem: ValidationEntityInput = {
          ...assetData.allocationItems[assetAllocationItemIndex],
        };

        if (assetAllocationItem && Object.keys(assetAllocationItem).length) {
          if (!errors.assetData.allocationItems[assetAllocationItemIndex]) {
            errors.assetData.allocationItems[assetAllocationItemIndex] = {};
          }

          assetAllocationItemRequiredFields.forEach((field: string): void => {
            if (!assetAllocationItem[field] || !assetAllocationItem[field].toString().trim()) {
              errors.assetData.allocationItems[assetAllocationItemIndex][field] = 'Required';
            }
          });

          if (portfolioIds.includes(assetAllocationItem.portfolioId)) {
            errors.assetData.allocationItems[assetAllocationItemIndex].portfolioId = (
              'An item with this portfolio already exists'
            );
          } else {
            portfolioIds.push(assetAllocationItem.portfolioId);
          }

          if (errors.assetData.allocationItems[assetAllocationItemIndex]
            && !Object.keys(errors.assetData.allocationItems[assetAllocationItemIndex]).length) {
            delete errors.assetData.allocationItems[assetAllocationItemIndex];
          }
        }
      });

      if (errors.assetData.allocationItems && !Object.keys(errors.assetData.allocationItems).length) {
        delete errors.assetData.allocationItems;
      }
    }
  }

  if (errors.assetData && !Object.keys(errors.assetData).length) {
    delete errors.assetData;
  }

  return errors;
};

export default AssetValidator;
